/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ReactNode } from "react";
import { When } from "react-if";
import { Link } from "react-router-dom";
import { Message, Text, theme } from "@nordcloud/gnui";
import { ResourceExecutionErrorCode } from "~/generated/graphql";
import { getLogActionDescription } from "~/utils/logErrorCode";

type Props = {
  errorCode?: ResourceExecutionErrorCode | null;
  subtitle?: ReactNode;
};

const documentationHref =
  "https://docs.fleetcontrol.nordcloudapp.com/docs/troubleshooting#possible-causes-and-remedies";

function DocumentationLink() {
  return (
    <Link
      to={{ pathname: documentationHref }}
      target="_blank"
      rel="noreferrer"
      css={{
        color: theme.color.support.blue,
        fontWeight: theme.fontWeights.medium,
        textDecoration: "none",
      }}
    >
      documentation
    </Link>
  );
}

export function EventResourceExecutionErrorMessage({
  errorCode,
  subtitle = (
    <>
      For more details, check <DocumentationLink />
    </>
  ),
}: Props) {
  const title = getLogActionDescription(errorCode)?.text;

  return (
    <When condition={!!title}>
      <Message
        status="danger"
        image="danger"
        css={{ marginBottom: theme.spacing.spacing04 }}
      >
        <div>
          <Text
            mb={theme.spacing.spacing02}
            color={theme.color.text.error}
            weight="medium"
          >
            {title}
          </Text>
          <Text mb={0} size="md" color={theme.color.text.text02}>
            {subtitle}
          </Text>
        </div>
      </Message>
    </When>
  );
}
